import React, { useState } from 'react';
import { Button, Form, message } from 'antd';
import Logo from '../../components/Logo/Logo';
import { useNavigate } from 'react-router';
import FormInput from '../../components/Form/FormInput';
import { userVerifyEmailAPI } from '../../zustand/API';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EmailScreen = () => {
	const Navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const onFinish = async (values) => {
	setLoading(true);
	try {
		const response = await userVerifyEmailAPI(values);
		if (response?.status === 200) {
			toast.success(response?.data?.message);

			if (response?.data?.otpSend) {
				Navigate('/otp-verify', { state: { email: response?.data?.email } });
			}
		} else {
			toast.error(response?.message);
		}
	} catch (error) {
		toast.error('An error occurred, please try again later');
	} finally {
		setLoading(false);
	}
};

	return (
		<div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
			<div className="bg-white p-6 rounded-2xl shadow-lg w-96 text-center">
				<div className="mb-4">
					<div className="w-12 h-12 mx-auto mb-2">
						<Logo />
					</div>
					<h2 className="text-xl font-semibold">Sign in to your account</h2>
				</div>
				<p className="text-gray-600 mb-4">Sent OTP on Your Email</p>
				<Form
					name="verify"
					onFinish={onFinish}
					className="space-y-4 flex flex-col items-center w-full max-w-md"
					initialValues={{
						remember: true,
					}}
				>
					<FormInput name="email" placeholder="Email*" type="email" />

					<Form.Item className="w-4/5">
						<Button
							htmlType="submit"
							block
							loading={loading}
							className="w-4/5 bg-green-600 text-white rounded p-5"
						>
							{'Send OTP'}
						</Button>
					</Form.Item>
				</Form>
			</div>
		</div>
	);
};

export default EmailScreen;
